import { openDB } from "idb";

const DB_NAME = "IELTS-Exam-DB";
const DB_VERSION = 4; // Increase version to force an upgrade
const STORE_NAME = "audio-files";


let currentAudio = null;
let currentAudioFilename = null;
let currentAudioURL = null;

export function playAudio(audioBlob, filename, countingTimeLeft) {
  // stopAudio();

  currentAudioURL = URL.createObjectURL(audioBlob);
  const audio = new Audio(currentAudioURL);
  currentAudio = audio;
  currentAudioFilename = filename;




  audio.addEventListener("loadedmetadata", () => {
    const SECTION_DURATION = audio.duration

    // const audioDuration = audio.duration;
    const elapsedTime = SECTION_DURATION - countingTimeLeft;

    let startTime = elapsedTime;
    // console.log('SECTION_DURATION', SECTION_DURATION);
    // console.log('countingTimeLeft', countingTimeLeft);
    // console.log('elapsedTime', elapsedTime);



    audio.currentTime = startTime;
    audio.play();
  });

  audio.addEventListener("ended", () => {
    cleanupAudioRefs();
  });
}

export function stopAudio() {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio.src = "";
    if (currentAudioURL) URL.revokeObjectURL(currentAudioURL);
    cleanupAudioRefs();
  }
}

export function stopAudioIfPlaying(filename) {
  if (currentAudio && currentAudioFilename === filename) {
    stopAudio();
  }
}
function cleanupAudioRefs() {
  currentAudio = null;
  currentAudioFilename = null;
  currentAudioURL = null;
}



// 🔹 Ensure IndexedDB is initialized before use
async function initDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db, oldVersion, newVersion, transaction) {
      // console.log(`Upgrading database from v${oldVersion} to v${newVersion}`);

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        // console.log(`Creating object store: ${STORE_NAME}`);
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

// 🔹 Retrieve an MP3 file from IndexedDB
export async function getMP3(filename) {
  try {
    const db = await initDB();
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      console.error(`Object store "${STORE_NAME}" does not exist.`);
      return null;
    }

    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const file = await store.get(filename);

    return file || null;
  } catch (error) {
    console.error("Error retrieving MP3 file:", error);
    return null;
  }
}

// 🔹 Save an MP3 file to IndexedDB
export async function saveMP3(filename, blob) {
  try {
    const db = await initDB();

    if (!db.objectStoreNames.contains(STORE_NAME)) {
      console.error(`Object store "${STORE_NAME}" does not exist.`);
      return;
    }

    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    await store.put(blob, filename);
    await tx.done;

    // console.log("MP3 Successfully Saved:", filename);
  } catch (error) {
    console.error("Error saving MP3 file:", error);
  }
}

// 🔹 Check if an MP3 file exists in IndexedDB
export async function hasMP3(filename) {
  try {
    const db = await initDB();

    if (!db.objectStoreNames.contains(STORE_NAME)) {
      console.warn(`Object store "${STORE_NAME}" does not exist.`);
      return false;
    }

    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const file = await store.get(filename);

    return file !== undefined;
  } catch (error) {
    console.error("Error checking for MP3 file:", error);
    return false;
  }
}

export async function deleteIELTSExamDB() {
  try {
    await indexedDB.deleteDatabase(DB_NAME);
  } catch (error) {
    console.error(`Failed to delete database "${DB_NAME}":`, error);
  }
}

export async function deleteMP3(filename) {
  try {
    stopAudioIfPlaying(filename); // ✅ NEW — stops audio if same file playing

    const db = await initDB();
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    await store.delete(filename);
    await tx.done;

    return true;
  } catch (error) {
    console.error("Error deleting MP3 file:", error);
    return false;
  }
}

